import { TZDate } from "@date-fns/tz";
import { format } from "date-fns";
import { APP_DEFAULT_TIME_ZONE } from "./zoned-input";

/** Stored instants always display in the event's business zone, on server and client. */
export function formatEventDate(
  value: Date | string | number,
  pattern = "EEE, d MMM yyyy · h:mm a",
) {
  return format(new TZDate(new Date(value), APP_DEFAULT_TIME_ZONE), pattern);
}

export function eventMapsUrl(
  location: string | null | undefined,
): string | null {
  if (!location?.trim()) return null;
  const url = new URL("https://www.google.com/maps/search/");
  url.searchParams.set("api", "1");
  url.searchParams.set("query", location.trim());
  return url.toString();
}

export function eventCalendarUrl(input: {
  title: string;
  start: Date;
  end?: Date | null;
  location?: string | null;
}): string {
  const stamp = (date: Date) =>
    date
      .toISOString()
      .replace(/[-:]/g, "")
      .replace(/\.\d{3}Z$/, "Z");
  const url = new URL("https://calendar.google.com/calendar/render");
  url.searchParams.set("action", "TEMPLATE");
  url.searchParams.set("text", input.title);
  // Preserve the real instant. Never apply an IST offset to a UTC calendar stamp.
  url.searchParams.set(
    "dates",
    `${stamp(input.start)}/${stamp(input.end ?? input.start)}`,
  );
  url.searchParams.set("ctz", APP_DEFAULT_TIME_ZONE);
  if (input.location) url.searchParams.set("location", input.location);
  return url.toString();
}
